module.exports = __webpack_public_path__ + "static/img/1.acf35b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/1/1.png
// module id = 8k9O
// module chunks = 0